export default __webpack_public_path__ + "static/media/muyap-beyaz.6811a83c.png";